import api from '../../../../services/api'
import store from '../../../../store'

import type from './types';
import {Provider} from '../../models/interfaces';
import { ActionType } from '../../../../models/types';

const baseUrl = process.env.REACT_APP_PROVIDERDOCUMENT;

const setProviders = (data: any): ActionType => ({
  type: type.SET_PROVIDERS,
  payload: data
});
const setLoading = (data: boolean): ActionType => ({
  type: type.SET_LOADING_PROVIDERS,
  payload: data
});

export const getProviders = async (providerName: string) => {
  store.dispatch(setLoading(true));
  try {
    let parameter = 'find'
    if(providerName){
      parameter += `/?name=${providerName}`
    };
    const { data } = await api.get(`${baseUrl}/provider/${parameter}`);
    let res: Provider[] = data.data;
    if (res && res.length > 0) {
      store.dispatch(setProviders(res));
    }
  } catch (err) {
    console.log(err);
  } finally {
    store.dispatch(setLoading(false));
  }
};